import { IComponentConfig } from "@/app/@types/base-component";
import { ReactiveComponent } from "./base-component";
import { ref, Ref } from "vue";
import {
    DeliveryCombinedCode,
    DeliveryDirectCode,
    DeliveryInstallationCode,
} from "@/app/constants";

export type DeliveryItemConfig = IComponentConfig & {
    unit: string;
    delivery_type: string;
};
export class Delivery extends ReactiveComponent {
    constructor(config: IComponentConfig) {
        super({ ...config, type: "delivery" });
    }

    replaceDeliveryItems(deliveryItems: DeliveryItem[]) {
        this.replaceComponents("delivery-item", deliveryItems);
    }

    getDeliveryItems = () => {
        return this.components.filter(
            (component) => component.type === "delivery-item",
        );
    };

    // getInstallation = () => {
    //     return this.components.find((component: unknown) =>
    //         (component as DeliveryItem).isInstallationDelivery(),
    //     );
    // };
}

export class DeliveryItem extends ReactiveComponent {
    unit: Ref<string>;
    delivery_type: Ref<string> = ref("");
    constructor(config: DeliveryItemConfig) {
        super({ ...config, type: "delivery-item" });

        this.unit = ref(config.unit || "");
        this.delivery_type = ref(config.delivery_type || "");
    }

    // isCombinedDelivery = () => {
    //     return this.structureType?.value === DeliveryCombinedCode;
    // };

    // isDirectDelivery = () => {
    //     return this.structureType?.value === DeliveryDirectCode;
    // };

    // isInstallationDelivery = () => {
    //     return this.structureType?.value === DeliveryInstallationCode;
    // };
}

export type DeliveryWeightConfig = IComponentConfig & {
    glass_weight: number;
};
export class DeliveryWeightItem extends ReactiveComponent {
    glass_weight: Ref<number>;
    constructor(config: DeliveryWeightConfig) {
        super({ ...config, type: "delivery-weight-item" });

        this.glass_weight = ref(config.glass_weight || 0);
    }
}
